import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";

const ITEM_TYPE = "BANNER_ITEM";

export function DraggableBannerItem({
                                      index,
                                      onDropToIndex,
                                      children,
                                    }: {
  index: number;
  onDropToIndex: (fromIndex: number, toIndex: number) => void;
  children: React.ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ITEM_TYPE,
      item: { fromIndex: index },
      collect: (m: any) => ({ isDragging: m.isDragging() }),
    }),
    [index]
  );

  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: ITEM_TYPE,
      drop: (item: { fromIndex: number }) => {
        onDropToIndex(item.fromIndex, index);
      },
      collect: (m: any) => ({ isOver: m.isOver({ shallow: true }) }),
    }),
    [index, onDropToIndex]
  );

  drag(drop(ref));

  return (
    <div
      ref={ref}
      style={{
        opacity: isDragging ? 0.5 : 1,
        outline: isOver ? "2px dashed rgba(0,0,0,0.2)" : "none",
        borderRadius: 8,
        cursor: "grab",
        maxWidth: "700px",
        width: "100%",
      }}
    >
      {children}
    </div>
  );
}
